import React from 'react';

const ModeToggle = ({ isMobileMode, setIsMobileMode }) => (
  <button
    onClick={() => setIsMobileMode((prev) => !prev)}
    className="bg-white text-gray-800 px-2 py-2 rounded-lg font-medium flex items-center space-x-2 hover:bg-gray-100 transition-colors"
    title={isMobileMode ? 'Switch to Laptop Experience' : 'Switch to Phone Experience'}
  >
    {isMobileMode ? (
      // Laptop icon
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h14a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm0 0v12m18-12v12M2 19h20" /></svg>
    ) : (
      // Phone icon
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 4h10a2 2 0 012 2v12a2 2 0 01-2 2H7a2 2 0 01-2-2V6a2 2 0 012-2zm0 0V2m10 2V2m-6 16h4" /></svg>
    )}
    <span className="sr-only">Toggle UI Mode</span>
  </button>
);

export default ModeToggle; 